export const removeLetters = (str: string) => {
  return str.replace(/\D/g, "")
}
